module.exports = __webpack_public_path__ + "zl16-11165d83.png";